module.exports = __webpack_public_path__ + "static/assets/d0285f1906636f21d1149a4797b978dc.svg";